import { colors, elevation } from '@atlaskit/theme';
import Tooltip from '@atlaskit/tooltip';
import React from 'react';
import styled from 'styled-components';

import { redirect } from '../../../facade/window';
import { AnalyticsConsumerProps, withAnalytics } from '../../../hoc/withAnalytics';
import { Product } from '../../../store/productStore';
import { isNewTabClick } from '../../../util/event';
import { ellipsis } from '../../styled/text';
import { cardContainerStyle } from '../style';

import ProductIcon, { Container as IconContainer } from './ProductIcon';

type Props = Product & {
  className?: string;
  fullScreen?: boolean;
  hideSiteName?: boolean;
  joinable?: boolean;
  tabIndex?: number;
};

const Container = styled.a`
  ${cardContainerStyle};

  &:hover {
    > ${IconContainer} {
      ${elevation.e400};
    }
  }
`;

const ProductName = styled.div`
  font-weight: 600;
  font-size: 12px;
  color: ${colors.N800};
`;

const SiteName = styled.div`
  color: ${colors.N100};
  font-size: 12px;
  ${ellipsis};
`;

class ProductCard extends React.Component<Props & AnalyticsConsumerProps> {
  render() {
    const { className, icon, productName, siteName, url, hideSiteName } = this.props;
    return (
      <Container className={className} href={url} onClick={this.onClick} tabIndex={this.props.tabIndex}>
        <ProductIcon icon={icon} />
        <ProductName>{productName}</ProductName>
        {!hideSiteName && (
          <Tooltip content={siteName} delay={1000} hideTooltipOnMouseDown>
            <SiteName>{siteName}</SiteName>
          </Tooltip>
        )}
      </Container>
    );
  }

  private onClick = async (event: React.MouseEvent<HTMLElement>) => {
    const { cloudId, fullScreen, joinable, productName, siteName, url } = this.props;
    const isOpeningInNewTab = isNewTabClick(event);
    if (!isOpeningInNewTab) {
      event.preventDefault();
    }
    await this.props.analytics.ui('productCard', 'clicked', {
      cloudId,
      fullScreen,
      joinable,
      product: productName,
      siteName,
      url,
    });
    if (!isOpeningInNewTab) {
      redirect(url);
    }
  };
}

export default withAnalytics(ProductCard);
